import { useBlockProps } from '@wordpress/block-editor';
import FastFactsPreview from './preview';
import FastFactsSidePanel from './sidePanel';

/**
 * All the logic for the Fast Facts block is handled in the side panel
 * and preview components. This component is a simple wrapper that
 * renders the side panel and preview components. If you add richtext
 * to fast facts in future, you will need to add it here.
 */


const EditFastFacts = ({ attributes, setAttributes }) => {
  const blockProps = useBlockProps();

  const updateCardIcon = (index, iconUrl) => {
    const updatedCards = [...attributes.cards];
    updatedCards[index].icon = iconUrl;
    setAttributes({
      cards: newCards,
      textColorClass: attributes.textColorClass || 'black',
      headingColorClass: attributes.headingColorClass || 'purple'
    });

  };

  // console.log("Edit.js: ", { cards, textColorClass, headingColorClass, title });


  return (
    <div {...blockProps}>
      <FastFactsSidePanel attributes={attributes} setAttributes={setAttributes} />
      <FastFactsPreview attributes={attributes} />
    </div>
  );
};

export default EditFastFacts;
